import { Button } from "@mui/material";
import React from "react";
import "./Products.css";
import { add } from "../store/cartSlice";
import { useDispatch, useSelector } from "react-redux";
import { fetchProd } from "../store/productSlice.js";
import { STATUS } from "../store/productSlice.js";
import CircularProgress from "@mui/material/CircularProgress";
import ErrorIcon from "@mui/icons-material/Error";
const Products = () => {
  const dispatch = useDispatch();
  const { data: products, status } = useSelector((state) => state.product);
  // const [products, setProducts] = React.useState([]);

  React.useEffect(() => {
    dispatch(fetchProd());
    // const fetchProducts = async () => {
    //   // const res = await fetch("https://fakestoreapi.com/products");
    //   // const data = await res.json();
    //   setProducts(data);
    // };
    // fetchProducts();
  }, []);
  // console.log(status);
  const handleAdd = (product) => {
    dispatch(add(product));
  };

  if (status === STATUS.LOADING) {
    return (
      <CircularProgress
        style={{ margin: "auto", height: "200px", width: "200px" }}
      />
    );
  }

  if (status === STATUS.ERROR) {
    return (
      <h2>
        <ErrorIcon
          style={{ display: "block", fontSize: "400px", margin: "auto" }}
        />
        Somethings went wrong...
      </h2>
    );
  }
  return (
    <div className="cardset">
      {products.map((prod) => (
        <div className="card" key={prod.id}>
          <img src={prod.image} alt={prod.title} />
          <div className="info">
            <h4>{prod.title}</h4>
            <h4 style={{ color: "grey" }}>${prod.price}</h4>
          </div>
          <Button
            onClick={() => handleAdd(prod)}
            variant="contained"
            className="button"
          >
            Add to cart
          </Button>
        </div>
      ))}
    </div>
  );
};

export default Products;
